import { css } from "@emotion/core";
import normalize from "emotion-normalize";

const fontFace = css`
  ${normalize}

  :global {
    @font-face {
      font-family: Value Serif;
      font-display: swap;
      font-weight: 400;
      src: url("/fonts/value-serif.woff2") format("woff2"),
        url("/fonts/value-serif.woff") format("woff");
    }
    @font-face {
      font-family: Value Serif;
      font-display: swap;
      font-weight: 600;
      src: url("/fonts/value-serif.woff2") format("woff2"),
        url("/fonts/value-serif.woff") format("woff");
    }
    @font-face {
      font-family: Value Serif;
      font-display: swap;
      font-weight: 800;
      src: url("/fonts/value-serif.woff2") format("woff2"),
        url("/fonts/value-serif.woff") format("woff");
    }

    @font-face {
      font-family: "Helvetica Now";
      font-style: normal;
      font-weight: 400;
      font-display: swap;
      src: url("/fonts/helvetica-now-regular.woff2") format("woff2"),
        url("/fonts/helvetica-now-regular.woff") format("woff");
    }

    @font-face {
      font-family: "Helvetica Now";
      font-style: italic;
      font-weight: 400;
      font-display: swap;
      src: url("/fonts/helvetica-now-italic.woff2") format("woff2"),
        url("/fonts/helvetica-now-italic.woff") format("woff");
    }

    @font-face {
      font-family: "Helvetica Now";
      font-style: normal;
      font-weight: 600;
      font-display: swap;
      src: url("/fonts/helvetica-now-medium.woff2") format("woff2"),
        url("/fonts/helvetica-now-medium.woff") format("woff");
    }

    @font-face {
      font-family: "Helvetica Now";
      font-style: normal;
      font-weight: 800;
      font-display: swap;
      src: url("/fonts/helvetica-now-bold.woff2") format("woff2"),
        url("/fonts/helvetica-now-bold.woff") format("woff");
    }
  }

  body,
  html {
    font-size: 16px;
    font-family: Helvetica Now, Helvetica Neue, system-ui, -apple-system,
      BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }
`;

export default fontFace;
